import React, { useEffect } from 'react';
import { NavLink } from 'react-router-dom';

const Menu = ({ menuOpen, toggleMenu }) => {
  const menuItems = [
    { path: '/', label: 'Home' },
    { path: '/courses', label: 'Courses' },
    { path: '/placements', label: 'Placements' },
    { path: '/media', label: 'Media' },
    { path: '/about', label: 'About' },
    { path: '/contact', label: 'Contact' },
    // { path: '/enquiry', label: 'Enquiry' },
  ];

  // Disable body scroll when menu is open and re-enable when it's closed
  useEffect(() => {
    if (menuOpen) {
      // Disable scrolling
      document.body.style.overflow = 'hidden';
    } else {
      // Re-enable scrolling
      document.body.style.overflow = 'auto';
    }

    // Cleanup the effect when the component is unmounted or menuOpen changes
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [menuOpen]);

  return (
    <nav
      className={`fixed top-[90px] left-0 w-full h-screen bg-[#F01923] transform transition-transform duration-500 ease-in-out ${
        menuOpen ? 'translate-x-0' : '-translate-x-full'
      } md:static md:h-auto md:translate-x-0 md:bg-transparent z-40`}
    >
      <ul className="flex flex-col md:flex-row md:justify-center items-center h-full gap-10 p-8 md:p-0">
        {menuItems.map((item, index) => (
          <li
            key={item.path}
            className={`transform transition-all duration-500 ${
              menuOpen ? 'translate-x-0 opacity-100' : '-translate-x-full opacity-0'
            } md:translate-x-0 md:opacity-100`}
            style={{ transitionDelay: `${index * 100}ms` }}
          >
            <NavLink
              to={item.path}
              onClick={toggleMenu}
              className={({ isActive }) =>
                `relative text-sm text-white  transition-colors
                 before:content-[''] before:absolute before:-bottom-1 before:left-0 before:w-0 
                 before:h-0.5 before:rounded-full before:opacity-0 before:transition-all
                 before:duration-300 before:bg-white hover:before:w-full hover:before:opacity-100
                 ${isActive ? 'text-red-600 before:w-full before:opacity-100' : ''}`
              }
            >
              {item.label}
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  );
};

export default Menu;
